import { FC, PropsWithChildren } from 'react';
import { IntlFormattedMessage } from 'src/common/components/IntlFormattedMessage';
import { Loader } from 'src/common/components/Loader';
import styled from 'styled-components';

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 18.5rem;
`;

const StyledLoader = styled(Loader)`
  width: 3rem;
  height: 3rem;
`;

const LoaderText = styled.h2`
  margin-top: 1rem;
  text-align: center;
`;
interface WebSdkLoaderProps {
  isLoading: boolean;
}

const AspspSdkVerificationLoader: FC<PropsWithChildren<WebSdkLoaderProps>> = ({
  isLoading,
  children,
}) => {
  return isLoading ? (
    <LoaderWrapper>
      <StyledLoader />
      <LoaderText>
        <IntlFormattedMessage id="aspsp.continueVerification" />
      </LoaderText>
    </LoaderWrapper>
  ) : (
    <>{children}</>
  );
};

export default AspspSdkVerificationLoader;
